import React from "react";
import get from "lodash/get";
import Teams from "./Teams";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import WeekVideo from "./components/WeekVideo";
import TeamWeekSetting from "./components/TeamWeekSetting";
import moment from "moment";
import AddCycleModal from "../../../parts/modals/add-cycle";
import TeamEnd from "./components/TeamEnd";
import TeamUnpublish from "./components/TeamUnpublish";
import PublishTeam from "./components/PublishTeam";
import TeamPublished from "./components/TeamPublished";
import RemoveMember from "./components/RemoveMember";
import CreateChat from "./components/CreateChat";
import TeamInviteClients from "./components/TeamInviteClients";

const TeamsController = async ({ res, req, locals, load, api }) => {
  const { query = {}, params } = req;
  const coachOrganizationPermissions =
    locals?.activeUser?.organizationPermissions || [];
  // First look for the permissions that allow the coach to acces to the store -
  // - in the ORGANIZATION permissions
  // These are by now "Templates" and "PUSH"
  const organizationStorePermissions =
    locals?.organizationPermissions?.filter((permission) =>
      ["PUSH"].includes(permission.permission)
    ) || [];

  // Team Coach added literally alongside Owner/Admin, not migrated to a shared org-wide
  // predicate: that would also exempt Nutritionist, who still needs the org permission here
  // like a Coach does — matches Admin/Owner's blanket access per the PRD ("same write scope
  // as Admin. No restrictions by section"), which doesn't extend to Nutritionist.
  const bypassesStorePermissionCheck =
    locals?.organizationRoleName === "Owner" ||
    locals?.organizationRoleName === "Admin" ||
    locals?.organizationRoleName === "Team Coach";

  // Then, in the permisisons of the COACH, find the a permissions that matches with the ones that
  // allow the coach to access to the store
  if (
    locals?.activeUser?.organizationUserStatus &&
    !bypassesStorePermissionCheck &&
    !organizationStorePermissions.some((storePermission) =>
      coachOrganizationPermissions.includes(storePermission._id)
    )
  )
    return res.redirect("/coaching-portal/athletes");

  const queryEditCycleSettings = {
    cycle: params.cycleId,
  };

  await load("editCycle", queryEditCycleSettings);
  locals.query = query;
  const modal = get(query, "modal", {});

  const currentTab = query?.currentTab;
  if (currentTab === "overview") {
    const month = query?.month;

    locals.teamsOverviewMonth = query.month;

    await load(
      "teamsOverview",
      moment(month).month() + 1,
      moment(month).year(),
      params.cycleId
    );
  }

  locals.modal = {
    "week-video": (
      <WeekVideo
        video={query.video}
        cycleVideo={query.cycleVideo}
        locals={locals}
      />
    ),
    "week-settings": (
      <TeamWeekSetting
        program={query.program}
        cycle={locals?.editCycle}
        locals={locals}
      />
    ),
    "edit-team-info": <AddCycleModal />,
    "end-team": <TeamEnd locals={locals} />,
    "unpublish-team": (
      <TeamUnpublish
        cycleId={params.cycleId}
        cycleName={locals.editCycle.name}
      />
    ),
    "publish-team": (
      <PublishTeam
        locals={locals}
        cycleId={params.cycleId}
        cycleName={locals.editCycle.name}
      />
    ),
    "team-published": <TeamPublished locals={locals} />,
    "remove-member": (
      <RemoveMember
        locals={locals}
        cycleId={query.cycleId}
        memberId={query.memberId}
        memberName={query.memberName}
        cycleName={locals.editCycle.name}
      />
    ),
    "create-chat": <CreateChat locals={locals} cycleId={params.cycleId} />,
    "team-invite-clients": <TeamInviteClients locals={locals} />,
    "activity-feed": <ActivityDrawer />,
  }[modal.type];

  res.body = <Teams locals={locals} api={api} />;
};

export default TeamsController;
